import { useEffect, useRef, useState } from 'react';
import { Toolbar } from './Toolbar';
import styles from './document-viewer.module.css';

// A photo or scan, with zoom only — one page, nothing to search. 100% is the
// image fitted to the frame, never enlarged past its own size.
const ImageView = ({ src }) => {
  const measureRef = useRef(null);
  const [fitWidth, setFitWidth] = useState(0);
  const [naturalWidth, setNaturalWidth] = useState(0);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const node = measureRef.current;
    if (!node) return undefined;
    const measure = () => setFitWidth(node.clientWidth);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  const baseWidth = naturalWidth ? Math.min(naturalWidth, fitWidth) : fitWidth;

  return (
    <>
      <div className={styles.scroller}>
        <div ref={measureRef} className={styles.measure} />
        {/* onLoad reads the image's size; it is not a user interaction. */}
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <img
          src={src}
          alt=""
          className={styles.image}
          style={naturalWidth ? { width: Math.round(baseWidth * zoom) } : { maxWidth: '100%' }}
          onLoad={(e) => setNaturalWidth(e.currentTarget.naturalWidth)}
        />
      </div>
      {naturalWidth > 0 && (
        <div className={styles.dock}>
          <Toolbar zoom={{ value: zoom, onChange: setZoom }} />
        </div>
      )}
    </>
  );
};

export default ImageView;
